export default __webpack_public_path__ + "img/a6a9a4f9c5f17bf771aac31c47e5f30e.png";